import React from "react";
const ServicesSection = () => {
  return <section className="home2-services">
      <div className="home2-section-content">
        <h2 className="home2-section-title">Nuestro trabajo no solo es generar informes.
        <br />
          Es ayudarte a decidir mejor.
        </h2>
        <p className="home2-section-intro">No somos una gestoría, pero trabajamos codo con codo con ella, para ordenar pasado y futuro.</p>

        <div className="home2-services-grid">
          {/* Bloque 1 */}
          <div className="home2-service-block">
            <span className="home2-service-number">1</span>
            <h3>Cierre financiero analítico</h3>
            <ul>
              <li>Analizar resultados, desviaciones y riesgos</li>
              <li>Identificar palancas reales de negocio</li>
              <li>Separar el ruido de la información relevante</li>
            </ul>
            <p className="home2-service-footer">
              No miramos solo qué ha pasado, sino por qué y qué implica.
            </p>
          </div>

          {/* Bloque 2 */}
          <div className="home2-service-block">
            <span className="home2-service-number">2</span>
            <h3>Reporting accionable</h3>
            <ul>
              <li>Reporting claro, estructurado y entendible</li>
              <li>Información útil para CEO, dirección y board</li>
              <li>KPIs clave para inversores</li>
            </ul>
            <p className="home2-service-footer">
              Menos dashboards decorativos. Más foco en lo que mueve la compañía.
            </p>
          </div>

          {/* Bloque 3 */}
          <div className="home2-service-block">
            <span className="home2-service-number">3</span>
            <h3>Acompañamiento estratégico</h3>
            <ul>
              <li>Conversaciones periódicas con CEO</li>
              <li>Participación en comités de dirección</li>
              <li>Apoyo en decisiones clave</li>
            </ul>
            <p className="home2-service-footer">
              Somos una voz financiera con criterio, no un proveedor externo.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default ServicesSection;